import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import HomePage from "@/pages/HomePage";
import InventarioPage from "@/pages/InventarioPage";
import VehicleDetailPage from "@/pages/VehicleDetailPage";
import ServiciosPage from "@/pages/ServiciosPage";
import ContactoPage from "@/pages/ContactoPage";
import LoginPage from "@/pages/LoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminVehicleForm from "@/pages/AdminVehicleForm";
import AdminCategories from "@/pages/AdminCategories";
import AdminImport from "@/pages/AdminImport";
import AdminSettings from "@/pages/AdminSettings";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/inventario" element={<InventarioPage />} />
      <Route path="/inventario/:categorySlug" element={<InventarioPage />} />
      <Route path="/vehiculo/:slug" element={<VehicleDetailPage />} />
      <Route path="/servicios" element={<ServiciosPage />} />
      <Route path="/contacto" element={<ContactoPage />} />
      
      {/* Admin Routes */}
      <Route path="/admin/login" element={<LoginPage />} />
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin/vehiculos/nuevo" 
        element={
          <ProtectedRoute>
            <AdminVehicleForm />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin/vehiculos/:id" 
        element={
          <ProtectedRoute>
            <AdminVehicleForm />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin/categorias" 
        element={
          <ProtectedRoute>
            <AdminCategories />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin/importar" 
        element={
          <ProtectedRoute>
            <AdminImport />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/admin/configuracion" 
        element={
          <ProtectedRoute>
            <AdminSettings />
          </ProtectedRoute>
        } 
      />
      
      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <WhatsAppButton />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
